export class LoginNotAuthorizedError extends Error {}
export class UserNotFoundError extends Error {}
export class UserAlreadyExistsError extends Error {}
export class EmailNotFoundError extends Error {}
export class PasswordResetNotValid extends Error {}
export class PasswordConfirmationInvalidError extends Error {}
